var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u952E\\u751F\\u6210\\u79FB\\u52A8\\u7AEF",
    stroke: "none",
    strokeWidth: 1,
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-271.000000, -731.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6211\\u7684",
    transform: "translate(271.000000, 731.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "yonghuming",
    transform: "translate(4.500000, 12.248398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2497711,12.2483979 L9.7493134,12.2483979 C6.85459262,12.2483979 4.5,14.6048215 4.5,17.4995423 L4.5,18.7497711 C4.5,19.9911504 5.50884956,21 6.75022887,21 L17.2488557,21 C18.490235,21 19.4990845,19.9911504 19.4990845,18.7497711 L19.4990845,17.4995423 C19.4990845,14.6048215 17.1444919,12.2483979 14.2497711,12.2483979 Z M17.2488557,19.4986268 L6.75022887,19.4986268 C6.33643576,19.4986268 5.99954226,19.1617333 5.99954226,18.7479402 L5.99954226,17.4995423 C5.99954226,15.4324077 7.68217882,13.7497711 9.7493134,13.7497711 L14.2497711,13.7497711 C16.3169057,13.7497711 17.9995423,15.4324077 17.9995423,17.4995423 L17.9995423,18.7479402 C17.9995423,19.1617333 17.6626488,19.4986268 17.2488557,19.4986268 Z",
    id: "\\u5F62\\u72B6",
    fill: "#999999",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3 C14.3472102,3 16.25,4.90278981 16.25,7.25 C16.25,9.59721019 14.3472102,11.5 12,11.5 C9.65278981,11.5 7.75,9.59721019 7.75,7.25 C7.75,4.90278981 9.65278981,3 12,3 Z M12,4.5 C10.4812169,4.5 9.25,5.73121694 9.25,7.25 C9.25,8.76878306 10.4812169,10 12,10 C13.5187831,10 14.75,8.76878306 14.75,7.25 C14.75,5.73121694 13.5187831,4.5 12,4.5 Z",
    id: "\\u692D\\u5706\\u5F62",
    fill: "#999999",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.1bf5aecf51485ee13c03f092186851d7.svg";
export { ForwardRef as ReactComponent };